import {
  KeyMilestonesPreview,
  PendingIntakeApprovalsPreview,
  PendingMilestoneApprovalsPreview,
  RecentlyApprovedIntakePreview,
  RecentlyApprovedMilestonesPreview,
  RoutingMilestoneApprovalsPreview,
} from "@/containers/Dashboard/Previews";

export const DASHBOARD_WIDGETS = [
  {
    id: "pendingIntakeApprovals",
    titleId: "dashboard.titles.pendingIntakeApprovals",
    Component: PendingIntakeApprovalsPreview,
  },
  {
    id: "pendingMilestoneApprovals",
    titleId: "dashboard.titles.pendingMilestoneApprovals",
    Component: PendingMilestoneApprovalsPreview,
  },
  {
    id: "recentlyApprovedIntake",
    titleId: "dashboard.titles.recentlyApprovedIntake",
    Component: RecentlyApprovedIntakePreview,
  },
  {
    id: "recentlyApprovedMilestones",
    titleId: "dashboard.titles.recentlyApprovedMilestones",
    Component: RecentlyApprovedMilestonesPreview,
  },
  {
    id: "routingMilestoneApprovals",
    titleId: "dashboard.titles.routingMilestoneApprovals",
    Component: RoutingMilestoneApprovalsPreview,
  },
  {
    id: "keyMilestones",
    titleId: "dashboard.titles.keyMilestones",
    Component: KeyMilestonesPreview,
  },
];

export const DASHBOARD_WIDGET_PREFERENCES_VERSION = 1;

export const getDefaultWidgetPreferences = () => ({
  version: DASHBOARD_WIDGET_PREFERENCES_VERSION,
  widgets: DASHBOARD_WIDGETS.map(({ id }) => ({ id, visible: true })),
});
